import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageBuilderDefaultButton, PbDefaultButtonOutput } from '@alfercom/fe-architecture-types';
import { Subject, Subscription, timer } from 'rxjs';

@Component({
  selector: '.crud-row-button',
  templateUrl: './crud-row-button.component.html',
  styleUrls: ['./crud-row-button.component.scss']
})
export class CrudRowButtonComponent implements OnInit {

  @Output() btnClickedIndex: EventEmitter<number> = new EventEmitter<number>();
  @Output() btnClickedOutput: EventEmitter<PbDefaultButtonOutput> = new EventEmitter<PbDefaultButtonOutput>();//gestione loading e messaggio di risposta //PbDefaultButtonOutput

  @Input() set iconOnly(_iconOnly: boolean) {
    this.showOnlyIcon = _iconOnly;
  }

  @Input() set button(button) {
    this.initConfigButton(button);
  }
  get button() {
    return this._button;
  }

  get btn() {
    return this._button;
  }

  @Input() btnIndex: number = undefined;

  _button:  PageBuilderDefaultButton | any; 

  showPopover: boolean;
  popoverSub: Subscription;

  showOnlyIcon: boolean = false;

  forceShowTooltip : boolean = false;

  constructor() { 
  }

  ngOnInit(): void {
  }

  initConfigButton(button: PageBuilderDefaultButton) { 
    if (button) {
      let classes = "";
      if (button.style == "default") {//BTN DEFAULT
        if (button.size == "small") {
          classes += " btn-sm "
        } else if (button.size == "large") {
          classes += " btn-lg "
        }
        if (button.type && button.type !== "reset") {
          classes += " btn-primary "
        } else {
          classes += " btn-muted "
        }
      } 
      button.customStyleClass += classes;
      this._button = button;
      if(button.help && button.help.openOnDrawing){
        this.showHelp();
      }
    }
  }

  showHelp(){
    setTimeout(()=>{
      this.forceShowTooltip=true;
    },500)
  }


  btnClick(confirmation: boolean = false) {
    if ((this.button && (this.button as PageBuilderDefaultButton).popConfirm && confirmation) || (this.button && !(this.button as PageBuilderDefaultButton).popConfirm)) { 
      this.btnClickedIndex.emit(this.btnIndex);
      (this.button as any).operation = {
        message: null,
        loading: false,
      }
      let sub: Subject<{
        loading?: boolean,
        message?: string
      }> = new Subject<{
        loading?: boolean,
        message?: string
      }>();
      sub.subscribe(
        res => {
          if (res) {
            (this.button as any).operation.loading = res.loading;
            (this.button as any).operation.message = res.message;
            this.changePopover(res.message !== null);
            if (!res.loading)//vuol dire che ho finito il caricamento
              sub.unsubscribe();
          }
        }
      )
      this.btnClickedOutput.emit({
        btn: this.button as any,
        sub
      })
    }
  }

  changePopover(newMsg: boolean) {
    if (this.popoverSub) {//se c'è già elimino
      this.popoverSub.unsubscribe();
      this.popoverSub = null;
      this.showPopover = false;//nascondo
    }
    if (newMsg) {//se devo mostrare qualcosa
      this.showPopover = true;//mostro
      const __timer = timer(2000);
      this.popoverSub = __timer.subscribe(val => this.showPopover = false);//aspetto due secondi e nascondo
    }
  }

}
